import React from "react";

export default function NoLocations() {
  return (
    <div className="m-5 flex p-3 text-center">
      <h4>E911 Information is not available.</h4>
    </div>
  );
}
